angular.module("acl.visualizer.notification", ["templates-visualizer"]);
